import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export default function InsightsPanelPieChart({ data }) {

    const colors = ['#1976D2', '#388E3C', '#F57C00'];  // Example: Warm Orange, Light Blue, and Soft Yellow

    return (
        <ResponsiveContainer width="100%" maxHeight='250px'>
            <PieChart>
                <Pie
                    data={data}
                    cx="50%"
                    cy="50%"
                    outerRadius={80}
                    fill="#8884d8"
                    dataKey="value"
                >
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                    ))}
                </Pie>
                <Tooltip />
                <Legend />
            </PieChart>
        </ResponsiveContainer>
    );
}
